import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Card } from "reactstrap";

const HeadersRole = ({ role, icon, svg, text }) => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const isUserProfilePage = location.pathname === "/profile";

  if (id) {
    return <></>;
  }
  return (
    <Card className="shadow-none mt-3 mb-5 ">
      <div className="p-3 d-flex align-items-center justify-content-between">
        <div className="d-flex flex-column">
          <h3 className=" fw-bold  text-dark d-flex align-items-center">
            {icon &&
              (svg ? (
                <img src={icon} alt="icon" className="me-3 mb-0" />
              ) : (
                <span className="me-3">{icon}</span>
              ))}

            {role}
          </h3>
          {text && text}
        </div>
        {isUserProfilePage && (
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => navigate("/resources")}
              className="btn btn-soft-primary border border-primary"
            >
              Resources
            </Button>{" "}
          </div>
        )}
      </div>
    </Card>
  );
};

export default HeadersRole;
